import { Modal } from 'bootstrap';
import { Artist } from 'shared/classes/Artist';
import { Invoice } from 'shared/classes/Billing';
import { SongOrder } from 'static/classes/Songgefluester';

export function AllSonggefluesterViewModel(data){

    //console.log(data);

    var self = this;
    self.type = "AllSonggefluesterViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

       // console.log('initing all past_events vm');

        if (!self.initialized()){
            self.lookup_sg_songs();
        }

        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(100);
        }
    };

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable(100);

    self.song_orders = ko.observableArray([]);

    self.error = ko.observable();
    self.search_name = ko.observable();
    self.only_past_due = ko.observable(false);

    self.search_name_click = function(){
        self.offset(0);
        self.lookup_sg_songs();
        return false;
    }


    self.lookup_sg_songs = function(){
        self.rootvm.is_busy(true);
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/songgefluester-songs',
            type: 'GET',
            data:{
                limit: self.limit() || 30,
                offset: self.offset(),
                search_name: self.search_name(),
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.song_orders(ko.utils.arrayMap( data.song_orders || [],
                    function(x){
                        const inv = x.fee_invoice;
                        if(inv){
                            inv.rootvm = self.rootvm
                            const i = new Invoice(inv);
                            x.fee_invoice = i
                        }


                        const a = x.artist;
                        a.rootvm = self.rootvm;
                        const artist = new Artist(a);
                        x.artist = artist;

                        return new SongOrder(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.total_count);

            },
            error: function (data) {
                notyf.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };


    // Selected Artist Modal
    self.selected_artist_info = ko.observable(new Artist({}));
    self.set_selected_artist_info = function(invoice){
        const artist = invoice.sender().artist()
        const modalArtistInfo = new Modal(document.getElementById('payinsArtistInfo'))
        if (self.selected_artist_info().artist_uuid() === artist.artist_uuid()) {
            modalArtistInfo.show();
        } else {
            self.selected_artist_info().artist_uuid(artist.artist_uuid());
            self.selected_artist_info().lookup_details().then((artist) => {
                self.selected_artist_info(artist);
                modalArtistInfo.show();
            });
        }
    };

    // Everything below is for paging -- should really create a
    // component at some point

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });



    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_sg_songs().then(function(){
            pager.navigate("#concerts/songgefluester"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_sg_songs().then(function(){
            pager.navigate("#concerts/songgefluester"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };

    //Set the selected info
    self.selected_song = ko.observable();
    self.set_song_info = (gys_song) =>{

        self.selected_song (gys_song);
        const gysSongInfo = document.getElementById('gysSongInfo');
        Modal.getOrCreateInstance(gysSongInfo).show();
        // Then open the modal
    }

    self.set_arist_filter = (gys_song) => {
        self.search_name(gys_song.artist.artist_name);

    }
};
